import { gql } from '@apollo/client';
import commentFragment from './EventComments/commentFragment';
import eventBidFragment from './eventBidFragment';
import userCommentAccessibilityOptionsFragment from './userCommentAccessibilityOptionsFragment';
import userEventParticipationInfoCalendarViewFragment from './userEventParticipationInfoCalendarViewFragment';

const SAVE_ASSIGNMENT_ACTION = gql`
  mutation SaveAssignmentAction($assignmentData: EventAppraiserAssignmentActionInput!) {
    saveAssignmentAction(assignmentData: $assignmentData) {
      AppraiserEvent {
        Id
        AtmAssignmentActionRequired
        TargetUserEventParticipationInfo {
          ...UserEventParticipationInfoFields
        }
        AppraiserEventComments {
          ...CommentFields
        }
        UserCommentAccessibilityOptions {
          ...UserCommentAccessibilityOptionsFields
        }
      }
      AppraiserEventBid {
        CanBidForEvent
        ...EventBidFields
      }
    }
  }

  ${userCommentAccessibilityOptionsFragment}
  ${commentFragment}
  ${eventBidFragment}
  ${userEventParticipationInfoCalendarViewFragment}
`;

export default SAVE_ASSIGNMENT_ACTION;
